import { z } from "zod";
import { safeParse } from "../../lib/zod";
import { isElementReference, Schema } from "../../common";
import { Targets } from "../../introspection";
import { ControlDefinition, serialize } from "../definition";
import { SlotControl } from "./slot-control";
class Definition extends ControlDefinition {
  static type = "makeswift::controls::slot";
  static get schema() {
    const type = z.literal(this.type);
    const columnData = z.object({
      count: z.number(),
      spans: z.array(z.array(z.number()))
    });
    const element = Schema.element.and(
      z.object({ deleted: z.boolean().optional() })
    );
    const data = z.object({
      elements: z.array(element),
      columns: Schema.responsiveValue(columnData)
    });
    const value = data;
    const definition = z.object({
      type
    });
    return {
      type,
      data,
      value,
      definition
    };
  }
  constructor() {
    super({});
  }
  get controlType() {
    return Definition.type;
  }
  get schema() {
    return {
      ...Definition.schema,
      resolvedValue: this.nodeSchema
    };
  }
  get nodeSchema() {
    return z.any();
  }
  safeParse(data) {
    return safeParse(this.schema.data, data);
  }
  fromData(data) {
    return data;
  }
  toData(value) {
    return value;
  }
  copyData(data, context) {
    if (data == null)
      return data;
    return {
      ...data,
      elements: data.elements.map((element) => context.copyElement(element))
    };
  }
  mergeData(base = { columns: [], elements: [] }, override = { columns: [], elements: [] }, context) {
    const mergedColumns = base.columns;
    const mergedElements = base.elements.flatMap((baseElement) => {
      const overrideElement = override.elements.find(
        (e) => baseElement.type === e.type && baseElement.key === e.key
      );
      if (overrideElement == null)
        return [baseElement];
      if (overrideElement.deleted)
        return [];
      if (isElementReference(overrideElement))
        return [overrideElement];
      if (isElementReference(baseElement))
        return [baseElement];
      return context.mergeElement(baseElement, overrideElement);
    });
    return { columns: mergedColumns, elements: mergedElements };
  }
  mergeTranslatedData(data, _translatedData, context) {
    return {
      ...data,
      elements: data.elements.map(
        (element) => context.mergeTranslatedData(element)
      )
    };
  }
  createInstance(sendMessage) {
    return new SlotControl(sendMessage);
  }
  serialize() {
    return serialize(this.config, {
      type: Definition.type
    });
  }
  introspect(data, target) {
    if (data == null)
      return [];
    if (target.type == Targets.ChildrenElement.type) {
      return data.elements;
    }
    return [];
  }
}
export {
  Definition as SlotDefinition
};
//# sourceMappingURL=slot.js.map